import { gql } from '@apollo/client';

export const GET_ALL_RESOURCE_ALLOCATIONS = gql`
  query MyQuery(
    $displayName: String
    $jobTitle: String
    $numProjects: Int
    $totalManHoursPerWeek: totalManHoursPerWeek
    $skillsFilter: [SkillFilter]
    $pagination: Pagination
  ) {
    getAllResourceAllocations(
      filter: {
        displayName: $displayName
        jobTitle: $jobTitle
        numProjects: $numProjects
        totalManHoursPerWeek: $totalManHoursPerWeek
        skillsFilter: $skillsFilter
      }
      pagination: $pagination
    ) {
      member {
        displayName
        jobTitle
        officeLocation
        userPrincipalName
        mobilePhone
        id
      }
      projects {
        hoursPerWeek
        memberStatus
        project {
          colorCode
          projectStatus
          projectName
          id
          tentativeStartDate
          tentativeEndDate
        }
        memberStatus
        roleStartDate
        roleEndDate
      }
      totalHoursPerWeek
      skills {
        id
        proficiencyLevel
        skill {
          id
          name
        }
      }
    }
  }
`;

export const GET_SKILLS = gql`
  query MyQuery {
    getSkills {
      name
      id
    }
  }
`;

export const GET_MEMBER_SKILLS = gql`
  query MyQuery($id: ID!) {
    getMemberSkills(memberId: $id) {
      id
      proficiencyLevel
      skill {
        id
        image
        name
      }
      validatorId
      status
    }
  }
`;
